export default __webpack_public_path__ + "static/media/logo-qrcode.d167de27.png";